export function convertVariables(text: string) {
  variables.map((variable) => {
    text = text.replace(variable.match, variable.value);
  });

  return text;
}

// export const emailURl = "https://staging.bmcal.com";
export const emailURl = "https://bmcal.com";

const a = `<div style="display:flex;"><a href="${emailURl}/g/{{hash}}">Add to Google</a>`;
const b = `<div style="display:flex; align-item:center; justify-content:start;">
<a style="width:max-content; display:flex; align-items:center; justify-content:center; text-decoration:none" target="_blank" href="${emailURl}/g/{{hash}}">
<span  style="color: #0e71eb;
padding: 5px 12px;
border-radius: 6px;
background-color: white;
width: fit-content;
text-decoration: none;
font-size: 14px;
border: 1px solid #0e71eb;
font-family: 'Lato', 'Helvetica', 'Arial';
cursor: pointer;"> <img style="width: 20px;
height: 20px;
margin-right: 8px;
vertical-align: top;" src="./images/GoogleCalendar.png" />Google Calendar</span>
</a>
`;

const variables = [
  {
    match: "{{calendar_buttons}}",
    value: `
          ${b}

          <a style="width:max-content; display:flex; align-items:center; justify-content:center; text-decoration:none; margin: 0 16px;" target="_blank" href="${emailURl}/i/{{hash}}">
          <span  style="color: #1071c1;
          padding: 5px 12px;
          border-radius: 6px;
          margin-right: 0;
          margin-left: 0;
          background-color: white;
          width: fit-content;
          text-decoration: none;
          font-size: 14px;
          border: 1px solid #1071c1;
          font-family: 'Lato', 'Helvetica', 'Arial';
          cursor: pointer;"> <img style="width: 20px;
          height: 20px;
          margin-right: 8px;
          vertical-align: top;" src="./images/Outlook.png" />Outlook Calendar (.ics)</span></a>
      
          <a style="width:max-content; display:flex; align-items:center; justify-content:center; text-decoration:none" target="_blank" href="${emailURl}/y/{{hash}}">
          <span  style="
          color: #a307d6;
          padding: 5px 12px;
          width: fit-content;
          border-radius: 6px;
          background-color: white;
          text-decoration: none;
          font-size: 14px;
          border: 1px solid #a307d6;
          font-family: 'Lato', 'Helvetica', 'Arial';
          cursor: pointer;"> <img style="width: 20px;
          height: 20px;
          margin-right: 8px;
          vertical-align: top;" src="./images/Yahoo.png" />Yahoo Calendar</span></a> </div>`,
  },
  {
    match: "{{calendar_google_raw}}",
    value: `${emailURl}/g/{{hash}}`,
  },
  {
    match: "{{calendar_yahoo_raw}}",
    value: `${emailURl}/y/{{hash}}`,
  },
  {
    match: "{{calendar_outlook_raw}}",
    value: `${emailURl}/i/{{hash}}`,
  },
  {
    match: "{{calendar_links}}",
    value: `${a}<a style="margin-right: 10px;margin-left: 10px;" href="${emailURl}/i/{{hash}}">Add to Outlook</a>
          <a href="${emailURl}/y/{{hash}}">Add to Yahoo</a></div>`,
  },
];
